import { Button, Modal, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import DataBreachService from '../../../../../services/DataBreach.service';
import useNotify from '../../../../../context/Notification/useNotify';

const ModalReject = ({
    open,
    title,
    text,
    handelClose,
    // handelOk,
    loading,
    width = 135,
    icon,
    confirmText = null,
    cancelText = null,
    form,
    id,
    setOpenConfirmEnd,
    setTriggerDetails,
    triggerDetails
}) => {
    const { t } = useTranslation('data-breach');
    const notify = useNotify();

    const handelOk = async (values) => {
        const payload = {
            txnDataBreachId: id,
            action: 'c703c7fc453942e9a686a45acb261c48',
            reason: values.reason,
        };

        DataBreachService.startDataBreach(payload)
            .then((res) => {
                if (res.data.resultMsg === 'SUCCESS') {
                    setOpenConfirmEnd(false);
                } else {
                    setOpenConfirmEnd(false);
                }
                setTriggerDetails(!triggerDetails)
            })
            .catch((err) => {
                notify({
                    type: 'error',
                    title: t('Fail'),
                    description: t('FailedtoSubmitData'),
                    closeable: true,
                    timeOut: 120000,
                });
            });
    };
    return (
        <Modal
            width={455}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center modal-reject">
                {icon}
                <div className="text-2xl font-semibold whitespace-pre-line">
                    {title}
                </div>
                <div className={`whitespace-pre-line text-[#65707A]`}>
                    {parse(text)}
                </div>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    onFinish={handelOk}
                    form={form}
                    className="w-full"
                    layout="vertical"
                >
                    <div className="flex">
                        <Form.Item
                            label={<span className="text-sm	font-normal">{t('Reason')}</span>}
                            name="reason"
                            className="mb-0 w-full"
                            rules={[
                                {
                                    required: true,
                                    message: t(
                                        'requiredField'
                                    ),
                                },
                            ]}
                        >
                            <Input.TextArea
                                size="large"
                                showCount
                                maxLength={500}
                                rows={2}
                                placeholder={t('Please explain the reason')}
                            />
                        </Form.Item>
                    </div>
                    <div className="flex justify-center items-center space-x-4 pt-8">
                        <Button
                            style={{ width }}
                            type="primary"
                            onClick={handelClose}
                            size="large"
                            ghost
                            className="w-36"
                        >
                            {cancelText ? cancelText : t('Cancel')}
                        </Button>

                        <Button
                            style={{ width }}
                            loading={loading}
                            size="large"
                            type="primary"
                            className="w-36"
                            htmlType="submit"
                        >
                            {confirmText ? confirmText : t('Confirm')}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
};
export default ModalReject;
